import React, { useState, useEffect } from "react";
import axios from "axios";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import ReactSwitchreview from 'react-switch'
import ReactSwitchsupport from 'react-switch'
import ReactPlayer from 'react-player'
import Modal from '../Modal/Modal';
import { isPro, getNoticeData, getNonce } from '../../Helpers';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css'
import NoticeModal from '../NoticeModal/NoticeModal';
import "./menu.scss"

const Menu = ({ noticeSettings }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [passview, setPassview] = useState(false);
    const [credentials, setCredentials] = useState([]);
    const [getGlobalURL, setGetGlobalURL] = useState(false);
    const [noticedata, setNoticedata] = useState(getNoticeData().wpntswebhook_menu_settings);
    const proData = isPro();

    const allConditionsMet = proData;

    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        type: 'confirmation',
        title: '',
        message: '',
        onConfirm: () => { },
        confirmText: 'Confirm',
        declineText: 'Cancel'
    });

    const closeModal = () => {
        setModalConfig(prev => ({ ...prev, isOpen: false }));
    };
    // Extract the last part of the URL as the site identifier
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const indexOfAdmin = pathParts.indexOf('wp-admin');
    const siteIdentifier = indexOfAdmin !== -1 ? pathParts.slice(indexOfAdmin - 1, indexOfAdmin).pop() : pathParts.slice(-1).pop();
    // Use the site identifier to create a unique localStorage key
    const localStorageKey = `wpnts_menu_settings_${siteIdentifier}`;
    //END ------------------


    const handleViewpass = () => {
        passview === true ? setPassview(false) : setPassview(true)
    }

    useEffect(() => {
        getWebhook();
    }, []);

    function getWebhook() {
        const wpnts_menu_settings = noticedata || {
            webhook: '',
            create_nav_menu: false,
            update_nav_menu: false,
            delete_nav_menu: false,

        };

        const formData = JSON.parse(localStorage.getItem(localStorageKey) || JSON.stringify(wpnts_menu_settings));
        setCredentials(formData);
    }




    const [wpntswebhook_menu_settings, setWebhook] = useState({
        webhook: credentials.webhook,
        delete_nav_menu: credentials.delete_nav_menu,
        create_nav_menu: credentials.create_nav_menu,
        update_nav_menu: credentials.update_nav_menu,

    });

    const handleGetGlobalURLChange = () => {
        const globalSlack = noticeSettings.wpnts_global_api_settings.global_webhook ?? '';
        setWebhook(prev => ({ ...prev, webhook: globalSlack }))
    };

    const handleChange = e => {
        setWebhook(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }


    /**
     * Realtime new leads collect
     */
    useEffect(() => {
        getNotice();
    }, [wpntswebhook_menu_settings]);
    function getNotice() {
        wp.ajax.send('notice_settings', {
            data: {
                nonce: getNonce()
            },
            success(response) {
                // console.log(response.notice_settings.wpntswebhook_menu_settings)
                setNoticedata(response.notice_settings.wpntswebhook_menu_settings);
            },
            error(error) {
                console.log(error)
            },
        });
    }




    /**
     * 
     * @param {Core WP CONFIG} e 
     * @returns 
     */
    const handleDelete_nav_menu = e => {
        setWebhook(prev => ({ ...prev, delete_nav_menu: e }));
    }

    /**
     * 
     * @param {HtAccess} e 
     * @returns 
     */
    const handleCreate_nav_menu = e => {
        setWebhook(prev => ({ ...prev, create_nav_menu: e }));
    }

    const handleUpdate_nav_menu = e => {
        setWebhook(prev => ({ ...prev, update_nav_menu: e }));
    }


    useEffect(() => {
        setWebhook({
            webhook: credentials.webhook,
            delete_nav_menu: credentials.delete_nav_menu,
            create_nav_menu: credentials.create_nav_menu,
            update_nav_menu: credentials.update_nav_menu,
        });
    }, [credentials]);


    const handleSave = async e => {
        e.preventDefault()
        localStorage.setItem(localStorageKey, JSON.stringify(wpntswebhook_menu_settings));

        //
        /**
         * Add new plugin list name 
         * 
         */
        const url = `${appLocalizer.wpntsUrl}/wpnts/v1/slack_webhook_menu_settings`;
        try {
            const res = await axios.post(url, {
                wpntswebhook_menu_settings

            }, {
                headers: {
                    'content-type': 'application/json',
                    'X-WP-NONCE': appLocalizer.nonce
                }
            }).then(function (res) {
                // console.log(wpntswebhook_menu_settings)
            });

        } catch (err) {
            console.log(err);
        }

        setModalConfig({
            isOpen: true,
            type: 'toast',
            title: 'success!',
            message: 'Webhook configure successfully',
            position: 'top-right'
        });
        setTimeout(closeModal, 3000);

    }
    return (
        <div className="acb_menu" id='acb_menu'>
            <div className="acb_left">
                <h3>Advance Menu settings panel
                    <a href="https://www.youtube.com/playlist?list=PL4m92NgWQaq5ttBH9gSYUX1r4c6rtgLg9" target="_blank"><PlayCircleIcon className='PlayCircleIcon' /></a>
                </h3>
                <br />

                <div className="wpnts-switch-sitessecurityissues">
                    {/* {!allConditionsMet ? <p className="PRO_TAG">PRO</p> : ''} */}
                    {/* <p className="NEW_TAG">New</p> */}
                    <div className={`media-feature`}>
                        <ReactSwitchsupport uncheckedIcon checkedIcon className="sitessecurity-supportSwitch-3" name="wpnts-switch-p-deactivation" id="create_nav_menu" onChange={handleCreate_nav_menu} checked={wpntswebhook_menu_settings.create_nav_menu} height={20} width={40} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" />
                        <label htmlFor="create_nav_menu">Navigation menu create event</label>
                        <Tippy content="You will be notified as soon as there are any changes to the Core .htaccess file on your site.">
                            <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                        </Tippy>

                    </div>
                </div>


                <div className="wpnts-switch-sitescriptmodification">
                    {/* {!allConditionsMet ? <p className="PRO_TAG">PRO</p> : ''} */}
                    {/* <p className="NEW_TAG">New</p> */}
                    <div className={`media-feature`}>
                        <ReactSwitchsupport uncheckedIcon checkedIcon className="sitessecurity-supportSwitch-2" name="wpnts-switch-p-activation" id="delete_nav_menu" onChange={handleDelete_nav_menu} checked={wpntswebhook_menu_settings.delete_nav_menu} height={20} width={40} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" />
                        <label htmlFor="delete_nav_menu">Navigation menu delete event:</label>
                        <Tippy content="You will be notified as soon as there are any changes to the Core wp-config file on your site.">
                            <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                        </Tippy>

                    </div>
                </div>



                <div className="wpnts-switch-sitessecurityissues">
                    {/* <p className="NEW_TAG">New</p> */}
                    <div className={`media-feature`}>
                        <ReactSwitchsupport uncheckedIcon checkedIcon className="sitessecurity-supportSwitch-3" name="wpnts-switch-p-deactivation" id="update_nav_menu" onChange={handleUpdate_nav_menu} checked={wpntswebhook_menu_settings.update_nav_menu} height={20} width={40} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" />
                        <label htmlFor="update_nav_menu">Navigation menu update event </label>
                        <Tippy content="You can track and log email submissions from your WordPress site.">
                            <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                        </Tippy>

                    </div>
                </div>


            </div>
            <div className="acb_right">

                {/* <form action="" id="wpntswebhook_menu_settings"> */}
                <form action="" id="wpnts_menu_settings">
                    <div className="formInput">
                        <label htmlFor="webhook">Webhook URL</label>
                        <div className="wpnts-setting">
                            <div className="passimg" onClick={handleViewpass}>
                                {passview === false ? <VisibilityOffIcon className='passVisibility' /> : <VisibilityIcon className='passVisibility' />}
                            </div>
                            <input type={passview === true ? "text" : "password"} placeholder="add webhook " name="webhook" required onChange={handleChange} value={wpntswebhook_menu_settings.webhook} />
                        </div>
                    </div>

                    <div className="getGlobalURLCheckbox">
                        <input
                            type="checkbox"
                            id="getGlobalURL"
                            checked={getGlobalURL}
                            onChange={handleGetGlobalURLChange}
                        />
                        <label htmlFor="getGlobalURL">Click to get slack global webhook</label>
                    </div>


                    <button className="save-webhook" onClick={handleSave}>SAVE</button>
                </form>

            </div>

            {/* <div className="acb_video">
              </div> */}


            {modalOpen && <><div class="wcs_popup_overlay"></div> <Modal setOpenModal={setModalOpen} /> </>}
            <NoticeModal
                isOpen={modalConfig.isOpen}
                onClose={closeModal}
                onConfirm={modalConfig.onConfirm}
                onDecline={closeModal}
                type={modalConfig.type}
                title={modalConfig.title}
                message={modalConfig.message}
                confirmText={modalConfig.confirmText}
                declineText={modalConfig.declineText}
                position={modalConfig.position || 'center'}
                autoClose={modalConfig.type === 'toast'}
                autoCloseTime={3000}
            />
        </div >
    )
}

export default Menu
